
import React from 'react';

const IntroSection: React.FC = () => {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              What is Industrial Hygiene?
            </h2>
            <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
              Industrial hygiene services protect and enhance worker health through identifying, evaluating, and controlling environmental hazards in the workplace that impair health, cause sickness, or contribute to significant discomfort among employees.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://static.readdy.ai/image/83c31d00f47a619d4f0a515f0b3bc954/c178c245a240755f2e3fc01fad04fb4d.jpeg"
                alt="Industrial Hygiene Services"
                className="w-full h-[400px] object-cover rounded-lg shadow-lg"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Comprehensive Workplace Safety Solutions
              </h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Our expert team provides comprehensive industrial hygiene assessments to identify potential workplace hazards and develop effective control strategies. We work with businesses across various industries to ensure compliance with OSHA regulations and protect employee health.
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-check-line text-green-600 text-xl"></i>
                  </div>
                  <span className="ml-3 text-gray-700">Air quality monitoring and assessment</span>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-check-line text-green-600 text-xl"></i>
                  </div>
                  <span className="ml-3 text-gray-700">Noise level evaluation and control</span>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-check-line text-green-600 text-xl"></i>
                  </div>
                  <span className="ml-3 text-gray-700">Chemical exposure assessments</span>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-check-line text-green-600 text-xl"></i>
                  </div>
                  <span className="ml-3 text-gray-700">Regulatory compliance guidance</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
